module.exports = __webpack_public_path__ + "img/operate_list2.306d27c3.png";